import React, { useState } from 'react';
import './PhotoGallery.css';

const PhotoGallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Sample gallery data - replace with your own images and descriptions
  const galleryItems = [
    {
      id: 1,
      image: '/images/Galerie_Mutke1.jpeg',
      title: 'Unsere Praxisräume',
      description: 'Moderne und einladende Räume für Ihre Behandlung'
    },
    {
      id: 2,
      image: '/images/Galerie_Mutke2.jpeg',
      title: 'Behandlungszimmer',
      description: 'Ausgestattet mit modernster Therapiegeräten'
    },
    {
      id: 3,
      image: '/images/Galerie_Mutke3.jpeg',
      title: 'Unser Team',
      description: 'Qualifizierte Fachkräfte für Ihre Gesundheit'
    },
    {
      id: 4,
      image: '/images/Galerie_Mutke4.jpeg',
      title: 'Therapiegeräte',
      description: 'Innovative Technologie für beste Ergebnisse'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === galleryItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? galleryItems.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Unsere Praxis in Bildern</h2>
      
      <div className="carousel">
        <button 
          className="carousel-btn carousel-btn-prev" 
          onClick={prevSlide}
          aria-label="Vorheriges Bild"
        >
          &#10094;
        </button>
        
        <div className="carousel-slide">
          <img 
            src={galleryItems[currentIndex].image} 
            alt={galleryItems[currentIndex].title}
            className="carousel-image"
          />
          <div className="carousel-caption">
            <h3>{galleryItems[currentIndex].title}</h3>
            <p>{galleryItems[currentIndex].description}</p>
          </div>
        </div>
        
        <button 
          className="carousel-btn carousel-btn-next" 
          onClick={nextSlide}
          aria-label="Nächstes Bild"
        >
          &#10095;
        </button>
      </div>
      
      <div className="carousel-indicators">
        {galleryItems.map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Gehe zu Slide ${index + 1}`}
          />
        ))}
      </div>
      
      <div className="gallery-thumbnails">
        {galleryItems.map((item, index) => (
          <div 
            key={item.id}
            className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          >
            <img 
              src={item.image} 
              alt={item.title}
              className="thumbnail-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;